import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Button from '../ui/Button';
import { clearAuth } from '../../features/auth/authSlice';

/**
 * Shared error state for the two browse endpoints (GET /investor/
 * investment-plans, GET /investor/investment-plans/{uuid}). A 401 here
 * means the session is over (bad/expired token, refresh already failed) —
 * distinct from "couldn't reach the server", which is a plain retry.
 * Doesn't handle 404 (that's "this specific plan doesn't exist", which
 * reads better as its own message — see PlanDetail.jsx).
 */
export default function PlanErrorState({ error, onRetry }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const status = error?.status;

  if (status === 401) {
    return (
      <div className="py-10 text-center space-y-3">
        <p className="text-sm text-foreground-muted">Your session has expired. Please log in again to continue.</p>
        <Button
          size="sm"
          onClick={() => {
            dispatch(clearAuth());
            navigate('/login');
          }}
        >
          Log in again
        </Button>
      </div>
    );
  }

  const message =
    status === undefined || status === 'FETCH_ERROR'
      ? "Couldn't reach the server. Check your connection and try again."
      : 'Something went wrong loading investment plans.';

  return (
    <div className="py-10 text-center space-y-3">
      <p className="text-sm text-foreground-muted">{message}</p>
      {onRetry && (
        <Button size="sm" variant="secondary" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
